import React from "react";
import './clients.css'
import Client1 from './assets/jll_logo_detail.png'
import Client2 from './assets/eqt-real-estate.svg'
import Client3 from './assets/CBRE_logo.png'
import Client4 from './assets/vantrust-logo.png'
import Client5 from './assets/ahp_logo.svg'
import Client6 from './assets/NetJets-Logo.png'
import Client7 from './assets/ohio_state_wexner_medical_center_logo.jpg'
import Client8 from './assets/colliers-logo.webp'


export default function Clients() {
  return (
    <div className=" main__container">
      <section className=" enable-animation ">
        <div className="marquee">
          <ul className="marquee__content">
            <div className=" marquee__item">
              <img src={Client1} alt="JLL | Commercial Real Estate and Property Investment" />
            </div>
            <div className=" marquee__item">
              <img src={Client2} alt="EQT Real Estate" />
            </div>
            <div className=" marquee__item">
              <img src={Client3} alt="CBRE: Global Commercial Real Estate Services" />
            </div>
            <div className=" marquee__item">
              <img src={Client4} alt="VanTrust Real Estate" />
            </div>
            <div className=" marquee__item">
              <img src={Client5} alt="American Health Packaging" />
            </div>
            <div className=" marquee__item">
              <img src={Client6} alt="NetJets | World's Leading Private Jet Company " />
            </div>
            <div className=" marquee__item">
              <img src={Client7} alt="The Ohio State University Wexner Medical Center" />
            </div>
            <div className=" marquee__item">
              <img src={Client8} alt="Colliers: Global Commercial Real Estate Services" />
            </div>
          </ul>

          <ul className="marquee__content">
            <div className=" marquee__item">
              <img src={Client1} alt="JLL | Commercial Real Estate and Property Investment" />
            </div>
            <div className=" marquee__item">
              <img src={Client2} alt="EQT Real Estate" />
            </div>
            <div className=" marquee__item">
              <img src={Client3} alt="CBRE: Global Commercial Real Estate Services" />
            </div>
            <div className=" marquee__item">
              <img src={Client4} alt="VanTrust Real Estate" />
            </div>
            <div className=" marquee__item">
              <img src={Client5} alt="American Health Packaging" />
            </div>
            <div className=" marquee__item">
              <img src={Client6} alt="NetJets | World's Leading Private Jet Company " />
            </div>
            <div className=" marquee__item">
              <img src={Client7} alt="The Ohio State University Wexner Medical Center" />
            </div>
            <div className=" marquee__item">
              <img src={Client8} alt="Colliers: Global Commercial Real Estate Services" />
            </div>
          </ul>
        </div>
      </section>
    </div>
  );
}